(function () {
  'use strict';

  const resolveTarget = (name) => {
    if (!name) return null;
    const id = name.trim().replace(/^#/, '');
    if (!id) return null;

    return (
      document.getElementById(id) ||
      document.querySelector(`[data-section-id="${id}"]`) ||
      document.querySelector(`#shopify-section-${id}`) ||
      document.querySelector(`.${id}`) ||
      null
    );
  };

  const initBogoFreeMerge = (root) => {
    if (!root || root.dataset.initialized === 'true') return;

    const trigger = root.querySelector('[data-bogo-free-merge-trigger]');
    if (!trigger) {
      root.dataset.initialized = 'true';
      return;
    }

    trigger.addEventListener('click', () => {
      const target = resolveTarget(root.dataset.bogoFreeMergeTarget);
      target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    root.dataset.initialized = 'true';
  };

  const initAll = () => {
    document.querySelectorAll('[data-bogo-free-merge]:not([data-initialized="true"])').forEach(initBogoFreeMerge);
  };

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-bogo-free-merge]');
    if (root) initBogoFreeMerge(root);
  });
})();
